import Api from "shared/service/api/api";

export const ITEM_STORE_NAMESPACE = "item";

//actions
const AUTOCOMPLETE = "autocomplete";
export const LOAD_ALL_ITEMS = "loadAllItems";
export const LOAD_COURSES = "loadCourses";
export const CREATE_ITEM = "createItem";
export const DELETE_ITEM = "deleteItem";
export const TOGGLE_ITEM = "toggleItem";
export const COPY_ITEM = "copyItem";

//mutations
export const SET_ALL_ITEMS = "setAllItems";
export const ADD_ITEM = "addItem";
export const UPDATE_ITEM = "updateItem";
export const SET_COURSES = "setCourses";
export const PUSH_FIXED_COURSE = "pushFixedCourse";
export const REPLACE_TO_FIXED_COURSES = "replaceToFixedCourses";

const state = {
  items: {
    list: [],
    page: 1,
    page_count: 1,
  },
  datasets: {
    fixed: {
      items: [],
      courses: [],
    },
    filter: {
      hide: [
        { value: "", text: "Любой" },
        { value: 0, text: "Нет" },
        { value: 1, text: "Да" },
      ],
      partnership: [
        { value: "", text: "Все" },
        { value: 0, text: "Нет" },
        { value: 1, text: "Да" },
      ],
      priceTypeId: [
        { value: "", text: "Все" },
        { value: 1, text: "Фиксированная цена" },
        { value: 2, text: "Рассрочка" },
        { value: 3, text: "Плавающая цена" },
        { value: 4, text: "Рекуррентный платёж" },
      ],
      callcenter: [
        { value: "", text: "-" },
        { value: 1, text: "Подключен" },
        { value: 0, text: "Не подключен" },
      ],
    },
    callAfterSet: [
      { value: 2, text: "2 часа" },
      { value: 4, text: "4 часа" },
      { value: 6, text: "6 часов" },
      { value: 0, text: "Задать свое значение" },
    ],
    recurringPaymentFrequencies: [
      { value: 7, text: "7 дней" },
      { value: 30, text: "30 дней" },
    ],
    items: [],
  },
};

const getters = {
  items: (state) => state.items.list || [],
};

const actions = {
  [LOAD_ALL_ITEMS]({ commit }, { page, filter, sort } = { page: 1, filter: {}, sort: {} }) {
    Api.item.all(page, filter, sort).then((response) => {
      if (!response.success) {
        throw new Error(response.error);
      }

      commit(SET_ALL_ITEMS, response.data);
    });
  },
  [CREATE_ITEM]({ commit }, { name, modelTypeId, label }) {
    return new Promise((resolve) => {
      Api.item
        .create({ name: name, model_type_id: modelTypeId, label })
        .then((response) => {
          if (!response.success) {
            throw new Error(response.error);
          }

          commit(ADD_ITEM, response.data);

          resolve(response.data);
        })
        .catch(() => {
          resolve(undefined);
        });
    });
  },
  [DELETE_ITEM]({ commit }, id) {
    return new Promise((resolve) => {
      Api.item
        .delete(id)
        .then((response) => {
          if (!response.success) {
            throw new Error(response.error);
          }

          commit(DELETE_ITEM, id);
        })
        .catch((e) => resolve(e));
    });
  },
  [TOGGLE_ITEM]({ commit }, id) {
    Api.item
      .toggle(id)
      .then((response) => {
        if (!response.success) {
          throw new Error(response.error);
        }

        commit(TOGGLE_ITEM, id);
      })
      .catch((e) => e);
  },
  [COPY_ITEM](_, id) {
    return Api.item.copy(id).then((response) => {
      if (!response.success) {
        throw new Error(response.error);
      }
    });
  },

  [LOAD_COURSES]({ dispatch }, query) {
    dispatch(AUTOCOMPLETE, {
      entity: "course",
      mutation: SET_COURSES,
      query: query,
    });
  },
  [PUSH_FIXED_COURSE]({ commit }, course) {
    commit(PUSH_FIXED_COURSE, course);
  },
  [REPLACE_TO_FIXED_COURSES]({ commit, state }, courseId) {
    if (!state.datasets.fixed.courses.find((fc) => fc.key === courseId)) {
      let course = state.datasets.courses.find((c) => c.key === courseId);
      commit(PUSH_FIXED_COURSE, course);
    }
  },
};

const mutations = {
  [SET_ALL_ITEMS](state, data) {
    state.items = data;
  },
  [DELETE_ITEM](state, id) {
    state.items.list = state.items.list.filter((item) => item.id !== id);
  },
  [TOGGLE_ITEM](state, id) {
    const item = state.items.list.find((item) => item.id === id);
    item.enabled = !item.enabled;
  },
  [ADD_ITEM](state, item) {
    state.items.list.unshift(item);
  },

  [SET_COURSES](state, courses) {
    state.datasets.courses = courses;
  },
  [PUSH_FIXED_COURSE](state, course) {
    if (!state.datasets.fixed.courses.find((c) => c.key === course.key)) {
      state.datasets.fixed.courses.push(course);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
